/* B.LÊM — revelar ao entrar + age gate */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.bl [data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function gate() {
    var el = document.getElementById('bl-gate');
    if (!el) return;
    var KEY = 'bl_age_ok';
    var ok = false;
    try { ok = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (ok || window.Shopify && Shopify.designMode) return;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { el.setAttribute('data-open', ''); });
    var yes = el.querySelector('[data-gate-yes]');
    var no = el.querySelector('[data-gate-no]');
    var back = el.querySelector('[data-gate-back]');
    if (yes) yes.focus({ preventScroll: true });
    yes && yes.addEventListener('click', function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      el.removeAttribute('data-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { el.hidden = true; }, reduce ? 0 : 260);
    });
    no && no.addEventListener('click', function () { el.setAttribute('data-denied', ''); back && back.focus(); });
    back && back.addEventListener('click', function () { el.removeAttribute('data-denied'); yes && yes.focus(); });
  }

  function init() { reveal(); gate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
